import { NBSP, currency } from './constants';

export const hasDecimal = (number: number | string) => {
    if (!number.toString().match(/[,.]/g)) {
        return false;
    }
    const splitOnCommaOrPeriod = number.toString().split(/[.,]/g);
    return splitOnCommaOrPeriod[splitOnCommaOrPeriod.length - 1].length <= 2;
};

export const roundNumberAndReturnAsString = (value: string | number) => {
    if (typeof value === 'number') {
        return Math.ceil(value).toString();
    }
    return value;
};

export const getAllExceptLastFromArray = (stringArray: string[]): string => {
    stringArray.pop();
    return stringArray.join(NBSP);
};

export const currencySubfix = `${NBSP}${currency}`;
